/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MerchantNames_storeLists$ref = any;
export type MerchantNamesQueryVariables = {|
  storeId: string
|};
export type MerchantNamesQueryResponse = {|
  +storeLists: ?{|
    +$fragmentRefs: MerchantNames_storeLists$ref
  |}
|};
export type MerchantNamesQuery = {|
  variables: MerchantNamesQueryVariables,
  response: MerchantNamesQueryResponse,
|};
*/


/*
query MerchantNamesQuery(
  $storeId: ID!
) {
  storeLists {
    ...MerchantNames_storeLists
    id
  }
}

fragment MerchantNames_storeLists on StoreLists {
  id
  merchantNames(storeId: $storeId) {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId",
    "type": "ID!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MerchantNamesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreLists",
        "kind": "LinkedField",
        "name": "storeLists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MerchantNames_storeLists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MerchantNamesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreLists",
        "kind": "LinkedField",
        "name": "storeLists",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "storeId",
                "variableName": "storeId"
              }
            ],
            "concreteType": "MerchantName",
            "kind": "LinkedField",
            "name": "merchantNames",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "MerchantNamesQuery",
    "operationKind": "query",
    "text": "query MerchantNamesQuery(\n  $storeId: ID!\n) {\n  storeLists {\n    ...MerchantNames_storeLists\n    id\n  }\n}\n\nfragment MerchantNames_storeLists on StoreLists {\n  id\n  merchantNames(storeId: $storeId) {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4abf1a16222a226de8691c99ac395a36';

module.exports = node;
